export type TreetopProperties = {
  baseUrl: string;
  version: string;
  production: boolean;
  publicLinkBaseUrl: string;
  workflowFrontendBaseUrl: string;
  publicLinkClinicalUrl?: string;
  hubUrl?: string;
  insights: {
    endpoint: string | null;
    connectionString: string | null;
  };
  authB2C: {
    defaultScopeName: string;
    tenant: string;
    tenantId: string;
    clientId: string;
    instance: string;
    signupsigninflow: string;
  };
  enableOffline: boolean;
};

const DEFAULT_TREETOP_PROPERTIES: TreetopProperties = {
  baseUrl: '',
  version: '1.0.0-dev',
  production: false,
  publicLinkBaseUrl: '',
  publicLinkClinicalUrl: undefined,
  hubUrl: undefined,
  workflowFrontendBaseUrl: '',
  insights: {
    endpoint: null,
    connectionString: null,
  },
  authB2C: {
    defaultScopeName: 'openid https://treetopguidelinesqab2c.onmicrosoft.com/treetop-guidelines-qa-b2c/full',
    tenant: 'treetopguidelinesqab2c',
    tenantId: 'b3913c25-27e5-4d9b-bd10-b9dfe84af096',
    clientId: 'ea810aa5-3bd4-4bf6-ac8f-26f23ef44285',
    instance: 'b2clogin.com',
    signupsigninflow: 'B2C_1A_SMART_HRD_SUSI',
  },
  enableOffline: false,
};

export class TreetopPropertiesProvider {
  private static _properties: TreetopProperties | undefined;

  static init(overrides: Partial<TreetopProperties> = {}) {
    this._properties = this.merge(DEFAULT_TREETOP_PROPERTIES, overrides);
  }

  static get properties(): TreetopProperties {
    if (!this._properties) {
      this._properties = { ...DEFAULT_TREETOP_PROPERTIES };
    }
    return this._properties;
  }

  private static merge(base: TreetopProperties, overrides: Partial<TreetopProperties>): TreetopProperties {
    const pick = <T>(b: T, o: T | undefined): T => (o === undefined ? b : o);

    return {
      baseUrl: pick(base.baseUrl, overrides.baseUrl),
      version: pick(base.version, overrides.version),
      production: pick(base.production, overrides.production),
      publicLinkBaseUrl: pick(base.publicLinkBaseUrl, overrides.publicLinkBaseUrl),
      publicLinkClinicalUrl: pick(base.publicLinkClinicalUrl, overrides.publicLinkClinicalUrl),
      hubUrl: pick(base.hubUrl, overrides.hubUrl),
      enableOffline: pick(base.enableOffline, overrides.enableOffline),
      workflowFrontendBaseUrl: pick(base.workflowFrontendBaseUrl, overrides.workflowFrontendBaseUrl),

      insights: {
        endpoint: pick(base.insights.endpoint, overrides.insights?.endpoint),
        connectionString: pick(base.insights.connectionString, overrides.insights?.connectionString),
      },

      authB2C: {
        defaultScopeName: pick(base.authB2C.defaultScopeName, overrides.authB2C?.defaultScopeName),
        tenant: pick(base.authB2C.tenant, overrides.authB2C?.tenant),
        tenantId: pick(base.authB2C.tenantId, overrides.authB2C?.tenantId),
        clientId: pick(base.authB2C.clientId, overrides.authB2C?.clientId),
        instance: pick(base.authB2C.instance, overrides.authB2C?.instance),
        signupsigninflow: pick(base.authB2C.signupsigninflow, overrides.authB2C?.signupsigninflow),
      },
    };
  }
}
